module.exports = __webpack_public_path__ + "static/media/nata.eb6def6a.jpg";